<template>
  <select
    v-model="order"
    class="c-select"
  >
    <option
      :value="{
        orderBy: 'name',
        sortOrder: 'asc',
      }"
      class="c-select__option"
    >
      Alfabetisk
    </option>
    <option
      :value="{
        orderBy: 'price',
        sortOrder: 'asc',
      }"
      class="c-select__option"
    >
      Pris (lav – høy)
    </option>
    <option
      :value="{
        orderBy: 'price',
        sortOrder: 'desc',
      }"
      class="c-select__option"
    >
      Pris (høy – lav)      
    </option>
    <option
      :value="{
        orderBy: 'size',
        sortOrder: 'asc',
      }"
      class="c-select__option"
    >
      Størrelse (liten – stor)
    </option>
    <option
      :value="{
        orderBy: 'size',
        sortOrder: 'desc',
      }"
      class="c-select__option"
    >
      Størrelse (stor – liten)
    </option>
    <option
      :value="{
        orderBy: 'bedroom_id',
        sortOrder: 'asc',
      }"
      class="c-select__option"
    >
      Antall soverom
    </option>
  </select>
</template>

<script>
import Residence from '@/models/Residence';

export default {
  name: 'Sorter',
  computed: {
    order: {
      get() {
        return this.$store.state.entities.residences.order;
      },
      set(newValue) {
        Residence.commit(state => {
          state.order = newValue;
        });
      },
    },
  },
  watch: {
    order() {
      this.registerEvent(this.order);
    },
  },
  methods: {
    registerEvent(event) {
      this.$gtag.event(`Endre sortering – ${event.orderBy}`, {
        event_category: 'Sorter',
        event_label: event.orderBy,
      });
    },
  },
};
</script>